import Box from '@mui/material/Box';
import AppDataGrid from '@shared/components/DataGrid';
import { useClientsQuery } from '../features/client/queries';
import { createClientListColumns } from '../features/client/components/columns';
import { useSearchParams } from 'react-router-dom';
import { useAppNavigate } from '@shared/store';

const ClientsPage = () => {
  const { data: clientList } = useClientsQuery();
  const navigate = useAppNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  const page = Number(searchParams.get('page') ?? 0);
  const pageSize = Number(searchParams.get('pageSize') ?? 100);

  if (!clientList?.length) {
    return null;
  }

  return (
    <Box sx={{ height: '100%' }}>
      <AppDataGrid
        rowHeight={80}
        rows={clientList}
        columns={createClientListColumns(navigate)}
        columnHeaderHeight={50}
        hideFooter={false}
        pageSizeOptions={[25, 50, 100]}
        paginationModel={{ page, pageSize }}
        onPaginationModelChange={model => {
          setSearchParams(
            { page: String(model.page), pageSize: String(model.pageSize) },
            { replace: true },
          );
        }}
        pagination
        paginationMode="client"
      />
    </Box>
  );
};

export default ClientsPage;
